import { ART } from "../assets";
import { Reveal } from "./Reveal";

const steps = [
  { n: "1", title: "Take photos", desc: "A quick snap of whatever's in the way.", img: ART.stepTakePhotos },
  { n: "2", title: "Get estimate", desc: "An honest price, read from your space.", img: ART.stepGetEstimate },
  { n: "3", title: "Book pickup", desc: "Choose a window that suits your day.", img: ART.stepBookPickup },
  { n: "4", title: "Enjoy your space", desc: "Walk back into a room that's yours.", img: ART.stepEnjoySpace },
];

export default function HowItWorks() {
  return (
    <section id="how" className="py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-violet/70">How it works</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display text-4xl leading-[1.02] tracking-tight text-charcoal sm:text-5xl lg:text-6xl text-balance">
              Four calm steps. That's the whole thing.
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="group">
                <div className="flex items-baseline gap-3">
                  <span className="font-display text-3xl text-violet/40">{s.n}</span>
                  <h3 className="font-display text-2xl text-charcoal">{s.title}</h3>
                </div>
                <p className="mt-2 text-charcoal/55">{s.desc}</p>
                <div className="mt-5 aspect-square overflow-hidden rounded-[2rem] bg-white/50 transition-transform duration-500 group-hover:-translate-y-1">
                  <img src={s.img} alt={s.title} className="h-full w-full object-cover" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
